import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Label } from "ui/components/label";
import { useNavigate } from "react-router-dom";
import { toolSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useToolForm } from "./useToolForm";
import SelectType from "components/select/type";

const ToolForm = ({ toolId }) => {
  
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useToolForm({
    toolId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      read={handleRead}
      update={handleUpdate}
      itemId={toolId || "+"}
      schema={toolSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        isUpdating,
        updateItem,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Name Field */}
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <Label required>Name</Label>
                <Input {...field} />
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Status */}
          <FormField
            control={form.control}
            name="type"
            render={({ field }) => (
              <FormItem>
                <Label>Type</Label>
                <SelectType
                  collection="tools"
                  onValueChange={val => field.onChange(val)}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
          />
        </div>
      )}
    </Form>
  );
};

export default ToolForm;
